import { GenericTableColumn } from '../../../../../shared/components/generic-table/models/table-column.model';
import { ACTION_ALERT_CONFIG } from '../../../constants/table-status-config.constants';
import { VarianceTableRow } from '../models/variance-table-row.model';

export function getVarianceSupportingDataTableColumns(): GenericTableColumn<VarianceTableRow>[] {
  return [
    {
      field: 'actionAlert',
      header: 'Action Alert',
      sortable: true,
      filterable: true,
      type: 'status',
      status: ACTION_ALERT_CONFIG,
      noWrap: true,
      width: '200px',
    },
    { field: 'medAmount', header: 'Med Amt', sortable: true, filterable: true },
    { field: 'uom', header: 'UOM', sortable: true, filterable: true },
    { field: 'transactionType', header: 'Type', sortable: true, filterable: true },
    { field: 'date', header: 'Date', sortable: true, filterable: true },
    { field: 'time', header: 'Time', sortable: true, filterable: true },
    { field: 'employee', header: 'Employee', sortable: true, filterable: true },
    { field: 'employeeId', header: 'Employee ID', sortable: true, filterable: true, width: '160px' },
    { field: 'role', header: 'Role', sortable: true, filterable: true },
    { field: 'clinicalUnit', header: 'Location', sortable: true, filterable: true, width: '160px' },
    {
      field: 'thumbnail',
      header: 'Video',
      type: 'thumbnail',
      sortable: false,
      filterable: false,
      align: 'center',
      thumbnail: {
        fallbackIcon: 'pi pi-image',
        videoUrl: (row: VarianceTableRow) => row.videoUrl ?? null,
        clickAriaLabel: 'table.video.playAria',
      },
    },
    { field: 'aiFlag', header: 'AI Flag', sortable: true, filterable: true },
    { field: 'rxIntercept', header: 'RX Intrcpt', sortable: true, filterable: true },
  ];
}
